<template>
    <Message
        :visible="hasErrors"
        class="form-field form-error bg-red-50 ring-red-200"
        :allow-dismiss="allowDismiss"
        @dismiss="$emit('dismiss')"
    >
        <template v-if="!isNested" #header>
            <h5 class="text-sm font-medium text-red-800">
                {{ heading || $t("api.messages.general_exception") }}
            </h5>
        </template>
        <div class="mt-2 text-sm text-red-700">
            <ul v-if="subErrors.length > 0" class="list-disc space-y-1 pl-5">
                <li
                    v-for="subError in subErrors"
                    :key="JSON.stringify(subError)"
                >
                    {{ $t(subError.error) }}
                </li>
            </ul>
            <p v-else-if="errorMessage">
                {{ $t(errorMessage) }}
            </p>
        </div>
        <p v-if="retryCallback">
            <button @click="retryCallback" class="btn btn-outline-primary">
                {{ retryLabel }}
            </button>
        </p>
    </Message>
</template>

<script>
import { getProperty, isObject } from "@/utils/object";

import Message from "./Message";

export default {
    name: "AlertItem",
    components: { Message },
    props: {
        error: {
            type: [Error, Object],
            required: false,
        },
        heading: {
            type: String,
            required: false,
        },
        isNested: {
            type: Boolean,
            required: false,
            default: false,
        },
        retryCallback: {
            type: Function,
            required: false,
        },
        retryLabel: {
            type: String,
            required: false,
            default() {
                return "Retry action";
            },
        },
        allowDismiss: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        getProperty,
        isObject,
    },
    computed: {
        errorMessage() {
            return getProperty(this.error, "message", null);
        },
        subErrors() {
            return getProperty(this.error, "errors", []);
        },
        hasErrors() {
            return isObject(this.error);
        },
    },
};
</script>
